import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Study } from '../../types';

export default function Studies() {
  const [studies, setStudies] = useState<Study[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudies = async () => {
      const { data } = await supabase
        .from('studies')
        .select('*')
        .order('study_date', { ascending: false })
        .limit(20);
      setStudies(data || []);
      setLoading(false);
    };
    fetchStudies();
  }, []);

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', { 
      day: 'numeric', 
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Estudios</h1>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
        </div>
      ) : studies.length === 0 ? (
        <div className="card text-center py-8">
          <p className="text-[#8E8E93]">No hay estudios disponibles</p>
        </div>
      ) : (
        <div className="space-y-3">
          {studies.map((study) => (
            <Link
              key={study.id}
              to={`/studies/${study.id}`}
              className="card block "
            >
              <h3 className="font-semibold text-white">{study.title}</h3>
              <p className="text-sm text-[#8E8E93] mt-1">📅 {formatDate(study.study_date)}</p>
              {study.description && (
                <p className="text-sm text-[#B3B3B3] mt-2 line-clamp-2">{study.description}</p>
              )}
              <div className="flex gap-2 mt-3">
                {study.pdf_url && <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded">PDF</span>}
                {study.video_url && <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">Video</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
